import { RECEIVE_DONATION_SUMMARY, REQUEST_DONATION_SUMMARY } from '../actions/donation-summary'

export default (
    state = {
        fetchSuccessful: null,
        isFetching: false,
        shouldFetch: true,
    },
    action
) => {
    const { type, data } = action

    switch (type) {
        case REQUEST_DONATION_SUMMARY:
            return { ...state, isFetching: true, shouldFetch: false }

        case RECEIVE_DONATION_SUMMARY: {
            return { ...state, ...data, isFetching: false }
        }

        default:
            return state
    }
}
